module.exports = __webpack_public_path__ + "static/goldm_1-c8c387b7b6d9ef616c9387e4e9c3ecc7.mp4";